export const DAILY_TASK_DESCRIPTION_MAX_LENGTH = 20000;

export const stripHtml = (value: string) =>
  value.replace(/<[^>]*>/g, '').replace(/&nbsp;/g, ' ').trim();

export const getDescriptionPlainLength = (value: string) =>
  stripHtml(value).length;
